import { Client } from "./client.model";
import { UserMapper } from "../user/user.mapper";
import { ClientContactPersonMapper } from "./client-contact-person-list/client-contact-person.mapper";
import { TierMapper } from "../tier/tier.mapper";
import { LocationMapper } from "app/location/location.mapper";
import { CompanyMapper } from "app/company/company.mapper";

export class ClientMapper {
  public static map(data: any): Client {
    return new Client(
      data.id,
      data.name,
      data.users
        ? data.users.length > 0
          ? data.users.map(UserMapper.map)
          : []
        : [],
      data.companies
        ? data.companies.length > 0
          ? data.companies.map(CompanyMapper.map)
          : []
        : [],
      data.contactPersons
        ? data.contactPersons.length > 0
          ? data.contactPersons.map(ClientContactPersonMapper.map)
          : []
        : [],
      data.accountOwner ? UserMapper.map(data.accountOwner) : null,
      data.ref,
      data.tin,
      data.street,
      data.postalCode,
      data.city,
      data.country,
      data.locale,
      data.greetings,
      data.hashtags,
      data.status,
      data.type,
      data.forwarder,
      data.paymentDays,
      data.notes,
      data.files ? data.files : [],
      data.bank,
      TierMapper.map(data.fclTier),
      new Date(data.createdAt),
      new Date(data.updatedAt),
      data.lastQuoteDate ? new Date(data.lastQuoteDate) : null,
      data.isEditable,
      data.clientTermsLocations
        ? data.clientTermsLocations.length > 0
          ? data.clientTermsLocations.map(LocationMapper.map)
          : []
        : [],
    );
  }
}
